import { StepperNumberOrientationType, StepperNumberStateType, } from '@kubit/web-ui-components/stepperNumber/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
import { stepBarCommonStyles, stepCircleCommonStyles, verticalCommonStyles } from '../commonStyles';
import { StepperVariantType } from '../variants';
export const getStepperVariantStyles = (FOUNDATIONS, FONT) => {
    return {
        [StepperVariantType.STEPPER]: {
            [StepperNumberOrientationType.VERTICAL]: {
                container: {
                    display: 'flex',
                    flex_direction: 'column',
                    gap: FOUNDATIONS.spacing_100,
                },
                [StepperNumberStateType.ACTIVE]: {
                    ...verticalCommonStyles(FOUNDATIONS, FONT),
                    stepCircle: {
                        ...stepCircleCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_comp_navigation_stepper_active_bg,
                        border_width: FOUNDATIONS.border_00,
                    },
                    stepName: {
                        font_variant: TextVariantType.FONT_PARAGRAPH_400,
                        font_weight: FONT_WEIGHT.font_weight_600,
                        color: FOUNDATIONS.color_neutral_font_50,
                    },
                    stepBar: {
                        ...stepBarCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_exception_secondary_bg_100,
                    },
                    stepIndex: {
                        ...verticalCommonStyles(FOUNDATIONS, FONT).stepIndex,
                        color: FOUNDATIONS.color_neutral_font_onsurface_100,
                    },
                },
                [StepperNumberStateType.COMPLETED]: {
                    ...verticalCommonStyles(FOUNDATIONS, FONT),
                    stepCircle: {
                        ...stepCircleCommonStyles(FOUNDATIONS, FONT),
                        background_color: 'transparent',
                        border_width: '0',
                        height: FOUNDATIONS.size_250,
                    },
                    stepName: {
                        font_variant: TextVariantType.FONT_PARAGRAPH_350,
                        font_weight: FONT_WEIGHT.font_regular,
                        color: FOUNDATIONS.color_neutral_font_50,
                    },
                    stepBar: {
                        ...stepBarCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_exception_secondary_bg_100,
                    },
                },
                [StepperNumberStateType.INACTIVE]: {
                    ...verticalCommonStyles(FOUNDATIONS, FONT),
                    stepCircle: {
                        ...stepCircleCommonStyles(FOUNDATIONS, FONT),
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        background_color: 'transparent',
                    },
                    stepName: {
                        font_variant: TextVariantType.FONT_PARAGRAPH_350,
                        font_weight: FONT_WEIGHT.font_regular,
                        color: FOUNDATIONS.color_neutral_font_50,
                    },
                    stepBar: {
                        ...stepBarCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_border_100,
                    },
                    stepIndex: {
                        ...verticalCommonStyles(FOUNDATIONS, FONT).stepIndex,
                        color: FOUNDATIONS.color_neutral_font_50,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=stepper.js.map